import * as React from 'react';
import { Expandable, ShouldTruncateTextAndLines } from 'ui/expandable';
import { PrimaryTitleProps, useContentRender } from 'ui/link-heading';
import { CompactTileContext } from 'ui/compact-tile/compact-tile-context';
import styles from './compact-tile-link-heading.scss';

export const CompactTileLinkHeading: React.FC<PrimaryTitleProps> = ({
  componentId,
  className,
  value,
  expandAll,
  textDisplayLess,
  textDisplayMore,
  maxLines,
  visibleTextLength
}) => {
  const compactTile = React.useContext(CompactTileContext);

  const shouldTruncate =
    ShouldTruncateTextAndLines(value, visibleTextLength, maxLines) && !expandAll;

  const contentRender = useContentRender(
    value,
    visibleTextLength,
    maxLines
  );

  const truncatedTitle = shouldTruncate ? styles.titleTruncated : '';

  const valueComponent = shouldTruncate ? (
    <Expandable
      content={contentRender}
      textDisplayLess={textDisplayLess}
      textDisplayMore={textDisplayMore}
    />
  ) : (
    value
  );

  const handleClick = () => {
    compactTile?.openDetails();
  };

  return (
    <>
      <h1
        id={componentId}
        className={`${styles.compactTileLinkHeading} ${className ?? ''} ${truncatedTitle}`}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
          }
        }}
      >
        {valueComponent}
      </h1>
    </>
  );
};
